// Single source of truth for the ActionCable endpoint. Pure and side-effect
// free, so every consumer can share it without opening a socket at import time.
// In development the URL is derived from the current origin, so a worktree on
// any port connects to its own server instead of a hardcoded :5000.
const buildCableUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}/cable`;
  }

  const onStaging = window.location.hostname === 'staging.medsender.com';
  const appUrl = onStaging ? 'staging.medsender.com' : 'app.medsender.com';
  return `wss://${appUrl}/cable`;
};

export default buildCableUrl;
